<template>
  <div
    :class="[
      'teamHonor' + posterData.teamHonorStatus,
      posterData.teamHonorStatus == 10 && !isSpring ? 'teamHonor10-2' : '',
      posterData.teamHonorStatus == 2 && !isSpring ? 'teamHonor2-2' : '',
      posterData.teamHonorStatus == 6 && year == '2024' && season == 'winter' ? 'teamHonor6-2' : '',
      currentSeason
    ]"
    class="teamHonor"
  >
    <img class="posterBg" :src="teamHonorBg" />

    <main>
      <!-- 1,16,17都是徽章在中部的 -->
      <div
        v-if="
          posterData.teamHonorStatus == 1 ||
          posterData.teamHonorStatus == 16 ||
          posterData.teamHonorStatus == 17
        "
        class="teamHonorStatus_1"
      >
        <section :class="[season == 'autumn' && posterData.teamHonorStatus == 1 ? 'autumnTeamSection' : ''] ">
          <h3>{{ teamInfo.teamName }}</h3>
          <address>{{ teamInfo.servicePointName }}</address>
          <!--秋季赛2期的冠军、季军、亚军海报需要特殊处理，UI设计稿不一样-->
          <img v-if="season != 'autumn' && posterData.teamHonorStatus != 1" :src="winnerPic" />
        </section>
        <footer :class="[season == 'autumn' && posterData.teamHonorStatus == 1 ? 'autumnTeamHonor' : ''] ">
          <dl>
            <dt>{{ posterData.posterDesc }}</dt>
            <dd>
              {{ timeFormatFilter(posterData.date) }}
            </dd>
          </dl>
          <img
            src="../../../../assets/images/winterGame/poster/committeeSeal.png"
          />
        </footer>
      </div>
      <div v-else class="otherStatus">
        <section>
          <h3>{{ teamInfo.teamName }}</h3>
          <address>{{ teamInfo.servicePointName }}</address>
          <!-- 战区名字 -->
          <div
            :class="[season == 'autumn' || ( year == '2024' && season == 'winter' && posterData.teamHonorStatus == 10) ? 'autumn-areaName' : 'areaName']"
            v-if="
              !isSpring &&
              (posterData.teamHonorStatus == 10 ||
                posterData.teamHonorStatus == 11 || posterData.teamHonorStatus == 19)
            "
          >
            <span v-if="posterData.teamHonorStatus == 19">{{ posterData.warZone }}赛区</span>
            <span v-else>{{ posterData.warZone }}</span>
          </div>
          <div
            class="areaName"
            v-if="!isSpring && posterData.teamHonorStatus == 15"
          >
            竞技场
          </div>
          <img :src="winnerPic" v-if="winnerPic" />
        </section>
        <footer :class="[ year == '2024' && (posterData.teamHonorStatus == 3 || posterData.teamHonorStatus == 5) ? 'winter_2024_footer' : '']">
          <dl>
            <dt
              v-if="
                posterData.teamHonorStatus !== 11 &&
                posterData.teamHonorStatus !== 12
              "
            >
              {{ posterData.posterDesc }}
            </dt>
            <dd>
              {{ timeFormatFilter(posterData.date) }}
            </dd>
          </dl>

          <img
            src="../../../../assets/images/winterGame/poster/committeeSeal.png"
            :class="[this.season + '_' + this.year]"
          />

          <!-- :style="gameTime !== '2023_spring' ? 'bottom:-30px' : ''" -->
        </footer>
      </div>
    </main>
  </div>
</template>

<script>
import winner1 from "../../../../assets/images/winterGame/poster/winner1.png";
import winner2 from "../../../../assets/images/winterGame/poster/winner2.png";
import winner3 from "../../../../assets/images/winterGame/poster/winner3.png";
import winNum3 from "../../../../assets/images/winterGame/winNum/win3.png";
import winNum4 from "../../../../assets/images/winterGame/winNum/win4.png";
import winNum5 from "../../../../assets/images/winterGame/winNum/win5.png";
import winNum6 from "../../../../assets/images/winterGame/winNum/win6.png";
import winNum7 from "../../../../assets/images/winterGame/winNum/win7.png";
import winNum8 from "../../../../assets/images/winterGame/winNum/win8.png";
import winNum9 from "../../../../assets/images/winterGame/winNum/win9.png";

import teamHonorBg1 from "../../../../assets/images/winterGame/poster/teamHonorBg1.png";
import teamHonorBg2 from "../../../../assets/images/winterGame/poster/teamHonorBg2.png";
import teamHonorBg3 from "../../../../assets/images/winterGame/poster/teamHonorBg3.png";
import teamHonorBg4 from "../../../../assets/images/winterGame/poster/teamHonorBg4.png";
import teamHonorBg5 from "../../../../assets/images/winterGame/poster/teamHonorBg5.png";
import teamHonorBg6 from "../../../../assets/images/winterGame/poster/teamHonorBg6.png";
import teamHonorBg10 from "../../../../assets/images/winterGame/poster/teamHonorBg10.png";
import battleReportBg1 from "@images/winterGame/poster/battleReportBg1.png";
import battleReportBg2 from "@images/winterGame/poster/battleReportBg2.png";
import { timeFormatFilter, judgeTempSeason } from "@/util/util.js";
export default {
  name: "teamHonor",
  data() {
    return {
      isSpring: false,
      teamHonorBg: null,
      year: "",
      season: "",
      currentSeason: '',
    };
  },
  methods: {
    timeFormatFilter(date) {
      return timeFormatFilter(date);
    },
  },
  props: {
    posterData: {
      type: Object,
      default: function () {
        return {
          realName: "",
          date: "",
          cupNumber: 0,
          posterDesc: "",
        };
      },
    },
    teamInfo: {
      type: Object,
      default: null,
    },
    // year: {
    //   type: Number,
    //   default: 2023,
    // },
    // season: {
    //   type: String,
    //   //default:'spring'
    //   default: "summer",
    // },
  },
  computed: {
    winnerPic: function () {
      [this.isSpring, this.year, this.season] = judgeTempSeason();
      if (this.$route.query.seasonId) {
        let { seasonId } = this.$route.query;
        if (seasonId.indexOf("chunji") > -1) {
          this.isSpring = true;
          this.season = "spring";
        } else if (seasonId.indexOf("xiaji") > -1) {
          this.isSpring = false;
          this.season = "summer";
        } else {
          this.isSpring = false;
          this.season = "autumn";
      }}
      if (this.posterData.teamHonorStatus == 1) {
        if (this.posterData.rank == 1) {
          return winner1;
        }
        if (this.posterData.rank == 2) {
          return winner2;
        }
        if (this.posterData.rank == 3) {
          return winner3;
        }
      }
      if (this.posterData.teamHonorStatus == 4) {
        if (this.posterData.winingNum == 3) {
          return winNum3;
        }
        if (this.posterData.winingNum == 4) {
          return winNum4;
        }
        if (this.posterData.winingNum == 5) {
          return winNum5;
        }
        if (this.posterData.winingNum == 6) {
          return winNum6;
        }
        if (this.posterData.winingNum == 7) {
          return winNum7;
        }
        if (this.posterData.winingNum == 8) {
          return winNum8;
        }
        if (this.posterData.winingNum == 9) {
          return winNum9;
        }
      }
      if (this.posterData.teamHonorStatus == 11) {
        return winner1;
      }
      if (this.posterData.teamHonorStatus == 12) {
        // 8 ，16，32  64 强
        if (this.posterData.winingNum == 1) {
          return require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/word/before_eight.png`);
        }
        if (this.posterData.winingNum == 2) {
          return require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/word/before_sixteen.png`);
        }
        if (this.posterData.winingNum == 3) {
          return require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/word/before_thirty_two.png`);
        }
        if (this.posterData.winingNum == 4) {
          return require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/word/before_64.png`);
        }
      }
      //自己构造的 rank 参数
      if (this.posterData.teamHonorStatus == 16) {
        //  竞技场1,2,3,4 名
        if (this.posterData.rank == 1) {
          return require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/word/jjc_first.png`);
        }
        if (this.posterData.rank == 2) {
          return require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/word/jjc_second.png`);
        }
        if (this.posterData.rank == 3) {
          return require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/word/jjc_third.png`);
        }
        if (this.posterData.rank == 4) {
          return require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/word/jjc_forth.png`);
        }
      }
      if (this.posterData.teamHonorStatus == 17) {
        return require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/word/dfs_first.png`);
      }
    },
  },
  mounted() {
    [this.isSpring, this.year, this.season] = judgeTempSeason();
    // this.posterData.teamHonorStatus = 14;
    // this.posterData.winingNum = 3;
    if (this.$route.query.seasonId) {
      let { seasonId } = this.$route.query;
      if (seasonId.indexOf("chunji") > -1) {
        this.isSpring = true;
        this.season = "spring";
      } else if (seasonId.indexOf("xiaji") > -1) {
        this.isSpring = false;
        this.season = "summer";
      } else if (seasonId.indexOf("qiuji") > -1) {
        this.isSpring = false;
        this.season = "autumn";
      } else {
        this.isSpring = false;
        this.season = "winter";
      }
      if (seasonId.indexOf('s.23') > -1) {
        this.year = '2023';
      } else if (seasonId.indexOf('s.24') > -1) {
        this.year = '2024';
      } else if (seasonId.indexOf('s.25') > -1) {
        this.year = '2025';
      }
    }
    this.currentSeason = `${this.season}_${this.year}`;
    console.log('this.currentSeason', this.currentSeason)
    if (this.isSpring) {
      if (this.posterData.teamHonorStatus == 1) {
        this.teamHonorBg = teamHonorBg1;
      }
      if (this.posterData.teamHonorStatus == 2) {
        this.teamHonorBg = teamHonorBg2;
      }
      if (this.posterData.teamHonorStatus == 3) {
        this.teamHonorBg = teamHonorBg3;
      }
      if (this.posterData.teamHonorStatus == 4) {
        this.teamHonorBg = teamHonorBg4;
      }
      if (this.posterData.teamHonorStatus == 5) {
        this.teamHonorBg = teamHonorBg5;
      }
      if (this.posterData.teamHonorStatus == 6) {
        this.teamHonorBg = teamHonorBg6;
      }
      if (this.posterData.teamHonorStatus == 10) {
        this.teamHonorBg = teamHonorBg10;
      }
    } else {
      console.log('this.posterData.teamHonorStatus', this.posterData.teamHonorStatus)
      if (this.posterData.teamHonorStatus == 1) {
        if (this.season != 'autumn') {
          this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/team_honor.png`);
        } else {
          if (this.posterData.rank == 1) {
            this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/team_honor_champion.png`);
          } else if (this.posterData.rank == 2) {
            this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/team_honor_yajun.png`);
          } else if (this.posterData.rank == 3) {
            this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/team_honor_jijun.png`);
          } else if (this.posterData.rank == 4) {
            this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/team_honor_si.png`);
          }
        }
      }
      if (this.posterData.teamHonorStatus == 2) {
        this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/today_best_team.png`);
      }
      if (this.posterData.teamHonorStatus == 3) {
        this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/today_best_team_2.png`);
      }
      if (this.posterData.teamHonorStatus == 4) {
        this.teamHonorBg = teamHonorBg4; //TODO
      }
      // 最精彩比赛
      if (this.posterData.teamHonorStatus == 5) {
        this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/best_game.png`);
      }
      // 满勤战队
      if (this.posterData.teamHonorStatus == 6) {
        this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/all_game.png`);
      }
      if (this.posterData.teamHonorStatus == 10) {
        //加战区
        this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/zhanqu_zuiqiang.png`);
      }
      //11：某战区冠军战队
      if (this.posterData.teamHonorStatus == 11) {
        //加战区
        this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/team_honor_area.png`);
      }
      //12：8 强、16强、32  64强战队
      if (this.posterData.teamHonorStatus == 12) {
        if (this.posterData.winingNum == 1) {
          this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/team_honor_order_8.png`);
        }
        if (this.posterData.winingNum == 2) {
          this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/team_honor_order_16.png`);
        }
        if (this.posterData.winingNum == 3) {
          this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/team_honor_order_32.png`);
        }
        if (this.posterData.winingNum == 4) {
          this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/team_honor_order_64.png`);
        }
      }
      //13：晋级精英争霸赛
      if (this.posterData.teamHonorStatus == 13) {
        this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/to_elite_game.png`);
      }
      //14：晋级全国大赛
      if (this.posterData.teamHonorStatus == 14) {
        this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/to_country_game.png`);
      }
      //15：竞技场今日最强战队
      if (this.posterData.teamHonorStatus == 15) {
        this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/jjc_today_best2.png`);
      }
      //16：竞技场1,2,3,4 名战队  ---  17：巅峰之王
      if (this.posterData.teamHonorStatus == 16) {
        if (this.posterData.rank == 1) {
          this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/jjc_honor1.png`);
        } else {
          this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/jjc_honor2.png`);
        }
      }
      if (this.posterData.teamHonorStatus == 17) {
        this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/dfs_honor1.png`);
      }
      if (this.posterData.teamHonorStatus == 19) {
        this.teamHonorBg = require(`../../../../assets/images/squirrelCup/${this.year}/${this.season}/poster/today_area_best_team.png`);
      }
    }
  },
};
</script>

<style lang="less" scoped>
.teamHonor {
  display: flex;
  flex-direction: column;
  main {
    top: 434px;
    position: absolute;
    left: 0;
    right: 0;
    address {
      font-style: normal;
    }
  }

  .posterBg {
    width: 100%;
  }
  .teamHonor1 {
    main {
      padding-top: 462px;
    }
  }
  &.teamHonor2 {
    .otherStatus {
      footer {
        margin-top: 472px;
        img {
          top: -150px;
        }
      }
    }
  }
  &.teamHonor10 {
    .otherStatus {
      footer {
        margin-top: 472px;
        img {
          top: 260px;
          &.autumn_2023 {
            top: 170px;
          }
          &.winter_2024 {
            top: 170px;
          }
        }
      }
      section:first-child {
        h3 {
          position: relative;
          top: -50px;
        }
        address {
          position: relative;
          top: -30px;
        }
      } 
    }
  }
  &.teamHonor3 {
    .otherStatus {
      footer {
        margin-top: 330px;
        dl {
          position: relative;
          top: 40px;
        }
        img {
          top: 320px;
          &.autumn_2023 {
            top: 180px;
          }
        }
      }
      .winter_2024_footer {
        margin-top: 300px;
        dl {
          position: relative;
          top: 40px;
        }
        img {
          top: -70px;
          &.winter_2024 {
            top: 180px;
          }
        }
      }
      section:first-child {
        h3 {
          position: relative;
          // top: -50px;
          margin-bottom: -10px;
        }
        address {
          position: relative;
          // top: -40px;
        }
      } 
    }
  }
  &.teamHonor4 {
    .otherStatus {
      footer {
        dl {
          position: relative;
          top: 40px;
        }
        margin-top: 285px;
        img {
          top: 40px;
        }
      }
    }
  }
  &.teamHonor5 {
    .otherStatus {
      footer {
        margin-top: 310px;
      }
      .winter_2024_footer {
        margin-top: 300px;
        dl {
          position: relative;
          top: -60px;
        }
        img {
          top: -70px;
          &.winter_2024 {
            top: 180px;
          }
        }
      }
    }
    section:first-child {
        h3 {
          position: relative;
          top: -50px;
        }
        address {
          position: relative;
          top: -40px;
        }
      } 
  }
  &.teamHonor6 {
    .otherStatus {
      footer {
        margin-top: 240px;
        img {
          top: 80px;
        }
      }
    }
  }
  &.teamHonor6-2 {
    main {
      top: 370px;
    }
    footer {
        img {
          top: -150px;
          &.winter_2024 {
            top: 100px;
          }
        }
      }
  }
  &.teamHonor2-2 {
    .otherStatus {
      footer {
        margin-top: 400px;
        img {
          top: 180px !important;
        }
      }
    }
  }
  &.teamHonor10-2 {
    .otherStatus {
      section:first-child {
        h3 {
          position: relative;
          top: -50px;
        }
        address {
          position: relative;
          top: -30px;
        }
        .areaName {
          margin-top: 0px;
        }
      } 
      footer {
        margin-top: 160px;
        dl {
          position: relative;
          top: 40px;
        }
        // img {
        //   top: 380px !important;
        // }
      }
    }
  }
  &.teamHonor11 {
    .otherStatus {
      section {
        img {
          margin-top: 0;
        }
      }
      footer {
        margin-top: 0px;
        dl {
          position: relative;
          top: 40px;
        }
        img {
          top: -70px;
        }
      }
    }
  }
  &.teamHonor12 {
    .otherStatus {
      footer {
        margin-top: 0px;
        dl {
          position: relative;
          top: 40px;
        }
        img {
          top: 380px !important;
        }
      }
    }
  }
  &.teamHonor13 {
    .otherStatus {
      footer {
        margin-top: 350px;
        dl {
          position: relative;
          top: 40px;
        }
        // img {
        //   top: 200px !important;
        // }
      }
    }
  }
  &.teamHonor14 {
    .otherStatus {
      footer {
        margin-top: 350px;
        dl {
          position: relative;
          top: 40px;
        }
        // img {
        //   top: 200px !important;
        // }
      }
    }
  }
  &.teamHonor15 {
    .otherStatus {
      footer {
        margin-top: 180px;
        dl {
          position: relative;
          top: 40px;
        }
        // img {
        //   top: 200px !important;
        // }
      }
    }
  }
  &.teamHonor19 {
    .areaName {
      margin-top: 30px;
    }
    .otherStatus {
      footer {
        margin-top: 220px;
      }
    }
  }
  .teamHonorStatus_1 {
    section {
      text-align: center;
      color: #ffffff;
      position: relative;
      &:first-child {
        p {
          margin: 0;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 40px;
        }
        address {
          height: 44px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 44px;
          font-style: normal;
        }
        h3 {
          margin-top: 16px;
          margin-bottom: 0;
          height: 98px;

          font-size: 48px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 98px;
        }
        img {
          margin-top: 80px;
          width: 500px;
        }
      }
      &.autumnTeamSection {
        h3 {
          margin-top: -35px;
        }
      }
    }
    footer {
      margin-top: 80px;
      position: relative;
      dl {
        text-align: center;
        margin: auto;
        dt {
          height: 44px;
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #fbf497;
          line-height: 44px;
        }
        dd {
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 40px;
          margin-left: 0;
        }
      }
      img {
        width: 259px;
        position: absolute;
        right: 10px;
        bottom: -200px;
      }
      &.autumnTeamHonor {
        margin-top: 250px;
      }
    }
  }

  .otherStatus {
    > img {
      width: 90%;
      margin: auto;
      display: block;
      position: absolute;
      top: 220px;
      left: 0;
      right: 0;
    }
    section {
      text-align: center;
      color: #ffffff;
      position: relative;
      margin-top: 20px;
      h3 {
        height: 66px;
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 66px;
        margin: 0 auto;
      }
      address {
        height: 44px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 44px;
      }
      img {
        margin-top: 80px;
        width: 500px;
      }
      .areaName {
        height: 146px;
        font-size: 104px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 146px;
        // margin-top: 50px;
      }
      .autumn-areaName {
        height: 166px;
        font-size: 104px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 146px;
        margin-top: 0px;
      }
      &:first-child {
        p {
          margin: 0;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 40px;
        }
        address {
          height: 44px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 44px;
          font-style: normal;
        }
        h3 {
          margin-top: 16px;
          margin-bottom: 0;
          height: 98px;

          font-size: 48px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 98px;
        }
      }
    }
    footer {
      margin-top: 590px;
      position: relative;
      // bottom: 0;
      dl {
        text-align: center;
        margin: auto;
        dt {
          height: 44px;
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: normal;
          color: #fbf497;
          line-height: 44px;
        }
        dd {
          margin-top: 10px;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 40px;
          margin-left: 0;
        }
      }
      img {
        width: 259px;
        position: absolute;
        right: 10px;
      }
      .spring_2023 {
        bottom: -130px;
      }
      .summer_2023 {
        top: 240px !important;
        right: 60px !important;
      }
    }
  }
}
</style>
